import Pictures from "./Pictures";

export default Pictures;
